import React, { useEffect, useState } from "react";
import fetchBase from "../utils/fetchBase";
import "./MyPassedShifts.css";

const MyPassedShifts = () => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const phone = localStorage.getItem("employee_phone");
                const token = localStorage.getItem("jwt_token");

                if (!phone || !token) {
                    setError("Missing authentication data.");
                    setLoading(false);
                    return;
                }

                const response = await fetch(
                    `${fetchBase}/time-log/history?phone=${encodeURIComponent(phone)}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch history.");
                }

                const data = await response.json();

                if (Array.isArray(data)) {
                    setHistory(data);
                } else {
                    setHistory([]);
                }
            } catch (err) {
                console.error("Error fetching history:", err);
                setError("Unable to load shift history.");
            } finally {
                setLoading(false);
            }
        };

        fetchHistory();
    }, []);

    if (loading) {
        return (
            <div className="history-container">
                <p>Loading shift history...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="history-container">
                <p className="error-text">{error}</p>
            </div>
        );
    }

const formatShiftDate = (dateString) => {
    if (!dateString) return "Unknown Date";

    const shiftDate = new Date(dateString);
    const today = new Date();

    // normalize both to midnight so time doesn't mess comparison
    shiftDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffTime = shiftDate - today;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "Tomorrow";

    return shiftDate.toLocaleDateString(undefined, {
        weekday: "short",
        month: "short",
        day: "numeric",
    });
};

    return (
        <div className="history-container">
            <h2>My Shift History</h2>

            {history.length === 0 ? (
                <p>No past shifts found.</p>
            ) : (
                history.map((shift, idx) => (
                    <div key={idx} className="history-tile">
                        <div className="history-date">
                            {formatShiftDate(shift.date)}
                        </div>

                        <div className="history-client">
                            {shift.clientName || "Unknown Client"}
                        </div>

                        <div className="history-time">
                            {shift.clockIn || "--"} → {shift.clockOut || "--"}
                        </div>

                        <div className="history-hours">
                            {shift.totalHours != null
                                ? `${shift.totalHours} hrs`
                                : "--"}
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default MyPassedShifts;